import {X} from 'lucide-react';
import {Button} from '@kroll-resolver-crisp/ui-components-react';
import {type ClassificationTreeNode} from '@/api/moderationQueue';
import {classificationLabel, type QueueFilters} from '@/lib/queueFilters';

type Props = {
  readonly filters: QueueFilters;
  readonly tree: readonly ClassificationTreeNode[];
  readonly onClear?: () => void;
};

// Where the classification filter sits in the taxonomy (Hate › Racial Hatred), with a way to drop it
// when onClear is given.
export function QueueClassificationPath({filters, tree, onClear}: Props) {
  if (!filters.classification) {
    return null;
  }

  return (
    <nav
      aria-label="Classification filter"
      className="border-border text-muted-foreground flex items-center gap-2 border-b px-3 py-1.5 text-xs">
      <span className="text-foreground min-w-0 truncate font-medium">
        {classificationLabel(filters, tree).join(' › ')}
        {filters.scope === 'own' ? ' (this level only)' : ''}
      </span>
      {onClear ? (
        <Button type="button" variant="ghost" size="sm" onClick={onClear}>
          <X data-icon="inline-start" />
          Clear classification
        </Button>
      ) : null}
    </nav>
  );
}
